import { render, staticRenderFns } from "./mySetup.vue?vue&type=template&id=69fc33b0&scoped=true"
import script from "./mySetup.vue?vue&type=script&lang=ts"
export * from "./mySetup.vue?vue&type=script&lang=ts"
import style0 from "./mySetup.vue?vue&type=style&index=0&id=69fc33b0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69fc33b0",
  null
  
)

export default component.exports